// @flow

import styled from 'styled-components';
import IframeChallenge from './IframeChallenge';
import includes from 'lodash/includes';

class FacebookAudienceNetworkChallenge extends IframeChallenge {
    static disablesSupportButton() {
        return true;
    }

    iFrameSource() {
        var format = this.props.challenge.displayFormat || 'banner';
        if (!includes(['native', 'banner'], format)) return null;
        const props = this.props;
        if (typeof props.challenge.placement !== 'string') return null;
        return `/fban_new.html?placement_id=${props.challenge.placement}&format=${props.challenge.displayFormat || "native"}&testmode=${props.challenge.testMode || 'false'}`;
    }

    eventReady() {
        super.eventReady();
        this.showSkipButtonWithTimeout(5000);
    }

    eventImpression() {
        super.eventImpression();
        this.trackImpression(() => {});
        this.trackAdOpportunity(true);
    }

    eventPassback() {
        super.eventPassback();
        this.trackAdOpportunity(false);
    }
}

const StyledFacebookAudienceNetworkChallenge = styled(FacebookAudienceNetworkChallenge)`
    #ad_root {
        display: none;
        font-size: 14px;
        height: 250px;
        line-height: 16px;
        position: relative;
        width: 300px;
    }
    .thirdPartyMediaClass {
        height: 157px;
        width: 300px;
    }
    .thirdPartyTitleClass {
        font-weight: 600;
        font-size: 16px;
        margin: 8px 0 4px 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .thirdPartyBodyClass {
        display: -webkit-box;
        height: 32px;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }
    .thirdPartyCallToActionClass {
        color: #326891;
        font-family: sans-serif;
        font-weight: 600;
        margin-top: 8px;
    }
    @media (orientation: portrait) {
        .skipVideo {
            bottom: 10px;
        }
    }
`;

export default StyledFacebookAudienceNetworkChallenge;



// WEBPACK FOOTER //
// ./src/campaign/challenges/external-sdks/FacebookAudienceNetworkChallenge.jsx